import React from "react";
import { Col, Row } from "reactstrap";
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent";

const LoanApplicationsOverview = () => {
  const data = [
    { label: "Total Loan Applications:", value: 3 },
    { label: "Approved Loans:", value: 1 },
    { label: "Pending Applications:", value: 1 },
    { label: "Rejected Applications:", value: 1 },
    { label: "Total Loan Amount Disbursed:", value: "$1000" },
  ];

  const loanApplications = [
    { id: "#1234567890", loanAmount: "$10,000", applicationDate: "20/07/2024", status: "Pending" },
    { id: "#1234567890", loanAmount: "$10,000", applicationDate: "20/07/2024", status: "Approved" },
    { id: "#1234567890", loanAmount: "$10,000", applicationDate: "20/07/2024", status: "Approved" },
    { id: "#1234567890", loanAmount: "$10,000", applicationDate: "20/07/2024", status: "Rejected" },
  ];

  const columns = [
    { name: "Application ID", selector: (row) => row.id, minWidth: "140px" },
    { name: "Loan Amount", selector: (row) => row.loanAmount, minWidth: "140px" },
    { name: "Application Date", selector: (row) => row.applicationDate, minWidth: "160px" },
    { name: "Status", selector: (row) => row.status, minWidth: "120px" },
    { name: "Action", cell: () => <span>View details</span>, minWidth: "120px" },
  ];

  return (
    <div>
      <div className="fw-semibold fs-5 mb-2">Summary Metrices</div>
      <Row className="mb-3 g-0 gap-3">
        <Col xs="12" lg="6" xxl="4" className="bg-white">
          <div className="rounded border border-black bg-white p-3 fw-medium">
            {data.map((item, index) => (
              <Row className="g-0" key={index}>
                <Col className="pe-2">{item.label}</Col>
                <Col xs="2" style={{ color: "#EC7426" }}>
                  {item.value}
                </Col>
              </Row>
            ))}
          </div>
        </Col>
      </Row>

      <div className="fw-semibold fs-5 mb-2">Loan Applications</div>
      <div className="bg-white p-3">
        <DatatableComponent
          data={loanApplications}
          columns={columns}
          type={"yellow"}
        />
      </div>
    </div>
  );
};

export default LoanApplicationsOverview;